'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _IntroModal = require('./IntroModal');

var _IntroModal2 = _interopRequireDefault(_IntroModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _IntroModal2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/IntroModal/index.js
// module id = 600
// module chunks = 11